var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',[_c('div',{staticClass:"d-flex flex-wrap station-list-view",staticStyle:{"gap":"14px"}},_vm._l((_vm.promotions),function(promotion){return _c('div',{key:promotion.id},[_c('PromoItem',{attrs:{"promo":promotion}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }